import React from "react";



function Export(){
    return(
        <>
            <h1>Export page</h1>       
        </>
    )
}



export default Export;